import { useState } from 'react';
export function useDraggable(id) {
    const [isDragging, setIsDragging] = useState(false);
    const handleDragStart = (event) => {
        event.dataTransfer.setData('text/plain', id);
        event.dataTransfer.dropEffect = 'move'; // eslint-disable-line no-param-reassign
        setIsDragging(true);
    };
    const handleDragEnd = () => {
        setIsDragging(false);
    };
    return {
        isDragging,
        draggableProps: {
            id,
            draggable: 'true',
            onDragStart: handleDragStart,
            onDragEnd: handleDragEnd,
        },
    };
}
